import { render, staticRenderFns } from "./WShipmentCustomValues.vue?vue&type=template&id=650daf58&scoped=true&"
import script from "./WShipmentCustomValues.vue?vue&type=script&lang=js&"
export * from "./WShipmentCustomValues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650daf58",
  null
  
)

export default component.exports